export default function GroupManagementInviteEntry({
  textareaRef,
  pasteText,
  handlePasteChange,
  errors,
  toInvite,
  handleAddToMembers,
  setAddMode,
}) {
  const styles = {
    card: {
      background: "#FFFFFF",
      border: "1px solid #E5E7EB", // gray-200
      borderRadius: 10,
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      padding: 16,
      marginTop: 24,
      marginBottom: 24,
    },
    h2: { fontSize: 18, fontWeight: 600, margin: "0 0 8px 0" },
    textarea: {
      width: "100%",
      height: 144, // h-36
      border: "1px solid #E5E7EB",
      borderRadius: 8,
      padding: 12,
      fontSize: 14,
      outline: "none",
    },
    invalid: { marginTop: 12, fontSize: 14, color: "#DC2626" }, // red-600
    invitesWrap: { marginTop: 16 },
    h3: { fontSize: 16, fontWeight: 600, margin: "0 0 8px 0" },
    row: (withTopBorder) => ({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "8px 0",
      borderTop: withTopBorder ? "1px solid #E5E7EB" : "none",
    }),
    role: { color: "#6B7280", fontSize: 14 }, // gray-500
    actions: { marginTop: 16, display: "flex", gap: 12 },
    primaryBtn: {
      padding: "8px 16px",
      background: "#2563EB", // blue-600
      color: "#FFFFFF",
      borderRadius: 8,
      border: "none",
      cursor: "pointer",
      fontSize: 14,
      fontWeight: 500,
    },
    secondaryBtn: {
      padding: "8px 12px",
      border: "1px solid #E5E7EB",
      borderRadius: 8,
      background: "#FFFFFF",
      fontSize: 14,
      cursor: "pointer",
    },
  };

  return (
    <div style={styles.card}>
      <h2 style={styles.h2}>Add Invites</h2>

      <textarea
        ref={textareaRef}
        value={pasteText}
        onChange={handlePasteChange}
        style={styles.textarea}
        placeholder="alice@example.com, bob@demo.com"
      />

      {errors.length > 0 && (
        <div style={styles.invalid}>
          <strong>Invalid:</strong> {errors.join(", ")}
        </div>
      )}

      {toInvite.length > 0 && (
        <div style={styles.invitesWrap}>
          <h3 style={styles.h3}>Invites to Send ({toInvite.length})</h3>

          <div>
            {toInvite.map((t, idx) => (
              <div key={t} style={styles.row(idx !== 0)}>
                <span>{t}</span>
                <span style={styles.role}>Member</span>
              </div>
            ))}
          </div>

          <div style={styles.actions}>
            <button onClick={handleAddToMembers} style={styles.primaryBtn}>
              Send Invites
            </button>
            <button onClick={() => setAddMode(false)} style={styles.secondaryBtn}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}



